import React from 'react';
import { Shimmer } from '../../CommonComponents/OPL/Shimmer/Shimmer';
import { Box } from '../../CommonComponents/OPL/Box/Box';

export const ExpensesLoading = () => {
  return (
    <>
      <Shimmer width={90} height={16} />

      <Box
        display="grid"
        css={`
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
        `}
        mt="8"
      >
        <Shimmer height={34} />
        <Shimmer height={34} />
        <Shimmer height={34} css="grid-column: 4" />
      </Box>
    </>
  );
};
